// ExternalIndicator v0.2.1 — clickable replacement for StatusDot when
// source_type === 'external'. We don't independently probe these providers,
// so a green/yellow/red dot would be misleading. The arrow + label is the
// only navigation affordance — click opens whatever human-facing status URL
// the upstream publishes (the source_url field). stopPropagation so a parent
// row's click handler (description tooltip) doesn't double-fire.
import type { MouseEvent } from 'react';

interface Props {
  href: string;
  label?: string;
}

export default function ExternalIndicator({ href, label = 'external' }: Props) {
  const onClick = (e: MouseEvent) => e.stopPropagation();
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      aria-label={`Open external ${label} status page`}
      className="inline-flex items-center gap-1 text-accent text-xs font-mono font-bold whitespace-nowrap hover:underline transition-colors"
    >
      ↗ external
    </a>
  );
}
